/**
 * Created by TapFun on 2024/12/02.
 */
import qs from 'qs';
import request from '@/common/request'
import {SERVER_HOST} from "@/common/portConfig";


// 查询用户未读站内消息个数
export const reqGetCountsOfUnreadNotice = params => {
    return request.get(`/admin/notice/countsOfUnread`, {
        params: params
    })
};

// 采购询价单 - 批量审核
export const reqBatchApproveInquiry = params => {
    return request.post(`/admin/inquiry/batchApprove`, params)
};

// 采购询价单 - 导入
export const reqImportInquiry = `${SERVER_HOST}admin/inquiry/importing`;

// 添加采购询价单
export const reqAddInquiry = params => {
    return request.post(`/admin/inquiry/add`, params)
};

// 提审采购询价单
export const reqSubmitInquiry = params => {
    return request.post(`/admin/inquiry/submit`, params)
};

// 查询采购询价单审核流程设置信息
export const reqGetInquiryApprovalSettings = params => {
    return request.get(`/admin/inquiry/approvalSettings`, {
        params: params
    })
};

// 根据id查询采购信息
export const reqGetInquiryById = params => {
    return request.get(`/admin/inquiry/one`, {
        params: params
    })
};

// 采购询价单-物资对应 - 分页查询
export const reqGetMaterialPage = params => {
    return request.get(`/admin/inquiryMaterial/page`, {
        params: params
    })
};

// 查询询价单物资列表
export const reqGetMaterialList = params => {
    return request.get(`/admin/inquiryMaterial/list`, {
        params: params
    })
};

// 根据code查询物资信息
export const reqGetMaterialsByCodes = params => {
    return request.post(`/admin/material/byCodes`, params)
};

// 查询对象审核历史信息
export const reqGetApprovalHistoryList = params => {
    return request.get(`/admin/approvalHistory/list`, {
        params: params
    })
};

// 审核采购询价单
export const reqApproveInquiry = params => {
    return request.post(`/admin/inquiry/approve`, params)
};

// 采购询价 - 删除
export const reqDelInquiry = params => {
    return request.delete(`/admin/inquiry/del`, {
        params: params
    })
};

// 报价管理 - 分页查询
export const reqGetQuotePage = params => {
    return request.get(`/admin/quote/page`, {
        params: params
    })
};

// 报价管理 - 撤销
export const reqCancelQuote= params => {
    return request.post(`/admin/quote/cancel`, params)
};

// 报价管理 - 导出
export const reqExportQuote = params => {
    return request.post(`/admin/quoteLine/export`, params, {responseType: 'blob'})
}

// 采购询价 - 发布
export const reqPublishInquiry = params => {
    return request.post(`/admin/inquiry/publish`, params)
};

// 查询询价单供应商报价列表
export const reqGetQuoteLines = params => {
    return request.get(`/admin/quoteLine/list`, {
        params: params
    })
};

// 分页查询询价单供应商报价列表
export const reqGetQuoteLinesPage = params => {
    return request.get(`/admin/quoteLine/page`, {
        params: params
    })
};

// 添加询价单报价
export const reqAddQuote = params => {
    return request.post(`/admin/quote/add`, params)
};


// 编辑采购询价单
export const reqEditInquiry = params => {
    return request.post(`/admin/inquiry/edit`, params)
};

// 查询报价附件
export const reqGetQuoteAttachments = params => {
    return request.get(`/admin/quote/attachments`, {
        params: params
    })
};

// 报价解密 - 分页查询
export const reqGetDeclassifyingPage = params => {
    return request.get(`/admin/declassifying/page`, {
        params: params
    })
};

// 报价解密 - 计划选项列表
export const reqGetDeclassifyingPlanOptions = params => {
    return request.get(`/admin/declassifying/plan/options`, {
        params: params
    })
};

// 报价解密 - 询价单状态选项列表
export const reqGetDeclassifyingStatusOptions = params => {
    return request.get(`/admin/declassifying/status/options`, {
        params: params
    })
};

// 报价解密 - 查询询价单物资及其默认/评选结果列表
export const reqGetDeclassifyingMaterials = params => {
    return request.get(`/admin/declassifying/materials`, {
        params: params
    })
};

// 报价解密 - 查询询价单供应商报价列表
export const reqGetLinesForMaterial = params => {
    return request.get(`/admin/quoteLine/material`, {
        params: params
    })
};

// 报价解密 - 评选
export const reqDeclassifyingChoosing = params => {
    return request.post(`/admin/declassifying/choosing`, params)
};

// 查询报价解密审核流程设置信息
export const reqGetDcApprovalSettings = params => {
    return request.get(`/admin/declassifying/approvalSettings`, {
        params: params
    })
};

// 提审报价解密
export const reqSubmitDeclassifying = params => {
    return request.post(`/admin/declassifying/submit`, params)
};

// Http类型定时任务 - 分页查询
export const reqGetHttpJobPage = params =>{
    return request.get(`/admin/quartz/httpJob/page`, {
        params: params
    })
};

// Http类型定时任务 - 任务管理：新增
export const reqAddHttpJob = params =>{
    return request.post(`/admin/quartz/httpJob/add`,params)
}

// 定时任务 - 任务管理：编辑
export const reqEditJob = params =>{
    return request.post(`/admin/quartz/job/edit`,params)
}

// 定时任务 - 任务管理：暂停
export const reqPauseJob = params =>{
    return request.post(`/admin/quartz/job/pause`,params)
}

// 定时任务 - 任务管理：恢复
export const reqResumeJob = params =>{
    return request.post(`/admin/quartz/job/resume`,params)
}

// 定时任务 - 任务管理：删除
export const reqDelJob = params =>{
    return request.post(`/admin/quartz/job/del`,params)
}

// 定时任务执行记录 - 分页查询
export const reqGetHttpJobLogsPage = params =>{
    return request.get(`/admin/quartz/httpJob/logs`, {
        params: params
    })
};

// 定时任务历史任务 - 分页查询
export const reqGetHttpJobHistoryPage = params =>{
    return request.get(`/admin/quartz/httpJob/history`, {
        params: params
    })
};

// 定时任务 - 下次运行时间
export const reqGetNext = params => {
    return request.get(`/admin/quartz/httpJob/getNext`, {
        params: params
    })
}

// 定时任务 - 上次运行时间
export const reqGetLastTime = params => {
    return request.get(`/admin/quartz/httpJob/getLastTime`,{
        params: params
    })
}

// 报价解密 - 成交结果发布审核
export const reqApproveDeclassifying = params => {
    return request.post(`/admin/declassifying/approve`, params)
};

// 报价解密 - 批量审核
export const reqBatchApproveDeclassifying = params => {
    return request.post(`/admin/declassifying/batchApprove`, params)
};

// 作废报价解密
export const reqCancelDeclassifying = params => {
    return request.post(`/admin/declassifying/cancel`, params)
};

// 报价解密 -询价作废审核
export const reqCancelApproveDeclassifying = params => {
    return request.post(`/admin/declassifying/cancelApprove`, params)
};

// 报价解密 - 生成通知书
export const reqGenerateNoticeZip = params => {
    return request.post(`/admin/declassifying/export-notices/${params.id}`)
};

// 报价解密 - 生成线下通知书
export const reqSupplementaryNoticeZip = params => {
    return request.post(`/admin/declassifying/export-supplementaryNotice/${params.id}`)
};

// 报价解密 - 发布计划结果
export const reqPublishPlanResult = params => {
    return request.post(`/admin/declassifying/publishResult/${params.id}`)
};

// 调剂公示 - 分页查询
export const reqGetAdjustmentPage = params => {
    return request.get(`/admin/adjustment/page`, {
        params: params
    })
};

// 调剂公示 - 添加
export const reqAddAdjustment = params => {
    return request.post(`/admin/adjustment/add`, params)
};

// 调剂公示 - 发布
export const reqPublishAdjustment = params => {
    return request.post(`/admin/adjustment/publish/${params.id}`)
};

// 调剂公示 - 根据id查询详情
export const reqGetAdjustmentById = params => {
    return request.get(`/admin/adjustment/one`, {
        params: params
    })
};

// 调剂公示 - 删除
export const reqDelAdjustment = params => {
    return request.delete(`/admin/adjustment/del`, {
        params: params
    })
};

// 调剂公示 - 编辑
export const reqEditAdjustment = params => {
    return request.post(`/admin/adjustment/edit`, params)
};

// 报价解密 - 分页查询评选物资列表
export const reqGetDeclassifyingMaterialPage = params => {
    return request.get(`/admin/declassifying/materialPage`, {
        params: params
    })
};

// 分页查询全单报价的供应商信息
export const reqGetFullQuotationSuppliers = params => {
    return request.get(`/admin/quote/fullQuotation/suppliers`, {
        params: params
    })
};

// 运行监控 - 分页查询
export const reqGetMonitoringPage = params => {
    return request.get(`/admin/monitoring/page`, {
        params: params
    })
};

// 查询已发布/作废的询价单列表
export const reqGetInquiryOptions = params => {
    return request.get(`/admin/report/inquiry/options`, {
        params: params
    })
};

// 分页查询价格评选报表
export const reqGetPriceChooseReport = params => {
    return request.post(`/admin/report/priceChoose`, params)
};

// 价格评选报表导出
export const reqExportPriceChooseReport = params => {
    return request.post(`/admin/report/priceChoose/export`, params, {responseType: 'blob'})
}

// 根据状态列表查询已解密的询价单列表
export const reqGetDeclassifiedInquiryOpts = params => {
    return request.post(`/admin/report/declassifiedInquiry/options`, params)
};

// 分页查询报价评选报表
export const reqGetQuoteChooseReport = params => {
    return request.post(`/admin/report/quoteChoose`, params)
};

// 报价评选报表导出
export const reqExportQuoteChooseReport = params => {
    return request.post(`/admin/report/quoteChoose/export`, params, {responseType: 'blob'})
}

// 查询询价物资参与报价的供应商信息
export const reqGetQuotedSuppliers = params => {
    return request.get(`/admin/declassifying/quotedSuppliers`, {
        params: params
    })
};

// 报价解密 - 补录
export const reqDeclassifyingSupplement = params => {
    return request.post(`/admin/declassifying/supplement`, params)
};
